ACC.thirtyDayMask = {
  leftNavigation: '.ph-leftnav-myaccount',
  maskBrandDropDown: '#maskBrand',
  productList: [],
  savedList: [],
  totalQty: 0,
  disableSavelistBtn: 'ph-savetolist_disabled',
  enableSavelistBtn: 'ph-savetolist_enabled',
  saveListBtn: 'ph-savetolist_btn',
  accumulatorIcon: 'ph-accumulatordata',
  accumulatorEnable: 'ph-accumulatordata-enabled',
  accumulatorDisable: 'ph-accumulatordata-disabled',
  accumulatorCount: 'ph-mask_total',
  disableButtonCls: 'ph-disabledbutton',
  buildNextBtnCls: 'ph-build-nextbtn',
  savedListLabel: 'SavedList',
  cartItems: '',
  defaultBrand: '',
  defaultConfigType: 'WITH_HEADGEAR',
  searchinput: 'ph-freetextsearch__input',
  breadcrumb: 'breadcrumb',
  breadcrumbCls: 'ph-repairs_breadcrumb',
  reviewSubmitBtnCls: '.ph-review-submitbtn',
  shippingPopupCls: 'ph-shipping-popup',
  termsCondPopupAgreeCls: '.ph-terms_popup_agree',
  acceptTermsBtnBig: '.ph-accept_terms_btn',
  selectBoxRefresh: 'refresh',
  defaultBrandLabel: 'defaultBrand',
  createProductListObject: function(productListItems) {
    ACC.thirtyDayMask.productList = productListItems.map(function(item) {
      item.quantity = 0;
      item.cartQuantity = 0;

      return item;
    });
  },
  maskBrandOptionIteration: function(items) {
    var optionsHtml = '<option value="" selected="selected">-----</option>';

    items.forEach(function(item) {
      optionsHtml = optionsHtml + '<option value=\'' + item.code + '\'>' + item.name + '</option>';
    });

    return optionsHtml;
  },
  populateMaskBrand: function(maskBrandList, maskBrand) {
    var maskBrandOptions = '';

    maskBrandOptions = ACC.thirtyDayMask.maskBrandOptionIteration(maskBrandList);
    $(ACC.thirtyDayMask.maskBrandDropDown).selectBox('destroy');
    $(ACC.thirtyDayMask.maskBrandDropDown).html(maskBrandOptions);
    $(ACC.thirtyDayMask.maskBrandDropDown).selectBox({
      mobile: 'true'
    });

    if (maskBrand.length > 0) {
      $(ACC.thirtyDayMask.maskBrandDropDown).val(maskBrand);
    } else {
      $(ACC.thirtyDayMask.maskBrandDropDown).val(ACC.thirtyDayMask.defaultBrand);
    }

    $(ACC.thirtyDayMask.maskBrandDropDown).selectBox(ACC.thirtyDayMask.selectBoxRefresh);
    ACC.common.refreshSelectBoxArrow();
  },
  populateConfigurationType: function(configType, configName) {
    if (configType.length > 0) {
      $('#ph-mask_configtype').html($('#configTypeTmpl').tmpl({
        configTypeList: configType
      }));
      $('#config_' + ACC.thirtyDayMask.defaultConfigType).attr('checked', true);

      if (configName.length > 0) {
        $('#config_' + configName).attr('checked', true);
      }
    }
  },
  getDefaultBrand: function() {
    $.ajax({
      url: ACC.config.contextPath + 'thirty-day-mask/getDefaultMaskBrand',
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        ACC.thirtyDayMask.defaultBrand = data;
        ACC.thirtyDayMask.getThirtyDayMaskProductList('', ACC.thirtyDayMask.defaultBrand, ACC.thirtyDayMask.defaultConfigType, true);
      },
      error: function() {
        $('.ph-json').text('Error');
      }
    });
  },
  getThirtyDayMaskProductList: function(searchTerm, maskBrand, configName, updateMaskConfig) {
    $.ajax({
      url: ACC.config.contextPath + 'thirty-day-mask/getThirtyDayMaskProductList?searchTerm=' + searchTerm + '&maskBrand=' + maskBrand + '&maskConfigurationame=' + configName,
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        ACC.thirtyDayMask.populateMaskBrand(data.maskBrandList, maskBrand);

        if (updateMaskConfig) {
          ACC.thirtyDayMask.populateConfigurationType(data.maskConfigurationTypeList, configName);
        }

        $('#ph-thirtyday_productlist').html($('#thirtyDayProductList').tmpl({
          productList: data.productList
        }));
        ACC.thirtyDayMask.createProductListObject(data.productList);
      },
      error: function() {
        $('.ph-json').text('Error');
      }
    });
  },
  enableSaveToList: function() {
    $('.' + ACC.thirtyDayMask.saveListBtn).removeClass(ACC.thirtyDayMask.disableSavelistBtn);
    $('.' + ACC.thirtyDayMask.saveListBtn).addClass(ACC.thirtyDayMask.enableSavelistBtn);
  },
  disableSaveToList: function() {
    $('.' + ACC.thirtyDayMask.saveListBtn).addClass(ACC.thirtyDayMask.disableSavelistBtn);
    $('.' + ACC.thirtyDayMask.saveListBtn).removeClass(ACC.thirtyDayMask.enableSavelistBtn);
  },
  updateQty: function(index, isAdd) {
    var $parentElm = $('[data-index="' + index + '"]'),
        $qtyElm = $parentElm.find('.ph-thirtyday_qtyinput'),
        currentQty = ACC.thirtyDayMask.productList[index].quantity;

    if (!isAdd && currentQty !== 0) {
      currentQty = currentQty - 1;
      ACC.thirtyDayMask.totalQty = ACC.thirtyDayMask.totalQty - 1;
    } else if (isAdd) {
      currentQty = currentQty + 1;
      ACC.thirtyDayMask.totalQty = ACC.thirtyDayMask.totalQty + 1;
    }

    if (ACC.thirtyDayMask.totalQty > 0) {
      ACC.thirtyDayMask.enableSaveToList();
    } else {
      ACC.thirtyDayMask.disableSaveToList();
    }

    ACC.thirtyDayMask.productList[index].quantity = currentQty;

    $qtyElm.val(currentQty);
  },
  clearUpdatedList: function() {
    for (var i = 0; i < ACC.thirtyDayMask.productList.length; i = i + 1) {
      ACC.thirtyDayMask.productList[i].quantity = 0;
    }
  },
  createCartItems: function() {
    ACC.thirtyDayMask.cartItems = ACC.thirtyDayMask.savedList.map(function(item) {
      return item.code;
    });
  },
  findByIndex: function(item) {
    var arrIndex = -1;

    for (var i = 0; i < ACC.thirtyDayMask.savedList.length; i = i + 1) {
      if (item.code === ACC.thirtyDayMask.savedList[i].code) {
        arrIndex = i;

        break;
      }
    }

    return arrIndex;
  },
  updateExistingCartItems: function(toBeSavedList) {
    $.each(toBeSavedList, function(k, v) {
      if (ACC.thirtyDayMask.cartItems.includes(v.code)) {
        var index = ACC.thirtyDayMask.findByIndex(v);

        ACC.thirtyDayMask.savedList[index].quantity = ACC.thirtyDayMask.savedList[index].quantity + v.quantity;
        ACC.thirtyDayMask.savedList[index].cartQuantity = ACC.thirtyDayMask.savedList[index].quantity;
      } else {
        ACC.thirtyDayMask.savedList.push($.extend({}, v));
        ACC.thirtyDayMask.cartItems.push(v.code);
      }
    });
  },
  returnSelectedProducts: function() {
    var selectedItems = [],
        productitem = '';

    for (var i = 0; i < ACC.thirtyDayMask.productList.length; i = i + 1) {
      if (ACC.thirtyDayMask.productList[i].quantity > 0) {
        ACC.thirtyDayMask.productList[i].cartQuantity = ACC.thirtyDayMask.productList[i].quantity;
        productitem = $.extend({}, ACC.thirtyDayMask.productList[i]);
        selectedItems.push(productitem);
      }
    }

    return selectedItems;
  },
  updateCartQty: function(index, isAdd) {
    var $parentElm = $('[data-productrow="' + index + '"]'),
        $qtyElm = $parentElm.find('.ph-thirtyday_qtyinput'),
        itemsInCart = '',
        currentQty = ACC.thirtyDayMask.savedList[index].cartQuantity;

    if (!isAdd && currentQty !== 0) {
      currentQty = currentQty - 1;
    } else if (isAdd) {
      currentQty = currentQty + 1;
    }

    if (currentQty === 0) {
      ACC.thirtyDayMask.savedList.splice(index, 1);
      itemsInCart = ACC.thirtyDayMask.savedList.length;
      ACC.thirtyDayMask.enableAccumulatorIcon();
      ACC.thirtyDayMask.persistSavedList();
      ACC.thirtyDayMask.createCartItems();
      ACC.thirtyDayMask.updatePopupTemplate();

      if (itemsInCart === 0) {
        ACC.thirtyDayMask.disableAccumulatorIcon();
        $('.' + ACC.thirtyDayMask.buildNextBtnCls).addClass(ACC.thirtyDayMask.disableButtonCls);
        $.colorbox.close();
      }
    } else {
      ACC.thirtyDayMask.savedList[index].cartQuantity = currentQty;
      $qtyElm.val(currentQty);
    }
  },
  updatePopupTemplate: function() {
    $('#ph-savedlist').html($('#savedProductList').tmpl({
      savedList: ACC.thirtyDayMask.savedList
    }));
  },
  persistSavedList: function() {
    localStorage.setItem(ACC.thirtyDayMask.savedListLabel, JSON.stringify(ACC.thirtyDayMask.savedList));
  },
  disableAccumulatorIcon: function() {
    $('.' + ACC.thirtyDayMask.accumulatorCount).html(0);
    $('.' + ACC.thirtyDayMask.accumulatorIcon).addClass(ACC.thirtyDayMask.accumulatorDisable);
    $('.' + ACC.thirtyDayMask.accumulatorIcon).removeClass(ACC.thirtyDayMask.accumulatorEnable);
  },
  enableAccumulatorIcon: function() {
    var totalCartQty = 0;

    totalCartQty = ACC.thirtyDayMask.getCartQuantity();
    $('.' + ACC.thirtyDayMask.accumulatorIcon).removeClass(ACC.thirtyDayMask.accumulatorDisable);
    $('.' + ACC.thirtyDayMask.accumulatorIcon).addClass(ACC.thirtyDayMask.accumulatorEnable);
    $('.' + ACC.thirtyDayMask.accumulatorCount).html(totalCartQty);
  },
  populateSavedListOnLoad: function() {
    var savedList = localStorage.getItem(ACC.thirtyDayMask.savedListLabel);

    if (savedList) {
      ACC.thirtyDayMask.savedList = JSON.parse(localStorage.getItem(ACC.thirtyDayMask.savedListLabel));
      ACC.thirtyDayMask.createCartItems();
      ACC.thirtyDayMask.updatePopupTemplate();

      if (ACC.thirtyDayMask.savedList.length > 0) {
        $('.' + ACC.thirtyDayMask.buildNextBtnCls).removeClass(ACC.thirtyDayMask.disableButtonCls);
        ACC.thirtyDayMask.enableAccumulatorIcon();
      }
    }
  },
  navigateToHome: function() {
    location.hash = 'thirtyDayHome';
    $('#' + ACC.thirtyDayMask.breadcrumb).removeClass(ACC.thirtyDayMask.breadcrumbCls);
    $(ACC.thirtyDayMask.leftNavigation).show();
  },
  navigateToBuild: function() {
    location.hash = 'build';
  },
  getCartQuantity: function() {
    var cartQty = 0;

    for (var i = 0; i < ACC.thirtyDayMask.savedList.length; i = i + 1) {
      cartQty = cartQty + ACC.thirtyDayMask.savedList[i].quantity;
    }

    return cartQty;
  },
  searchByParameters: function(maskBrandSel, configTypeSel) {
    var searchTermVal = $('.' + ACC.thirtyDayMask.searchinput).val();

    searchTermVal = $.trim(searchTermVal);
    ACC.thirtyDayMask.clearUpdatedList();
    ACC.thirtyDayMask.disableSaveToList();
    $('.ph-prdquantity').val(0);
    ACC.thirtyDayMask.defaultBrand = '';
    ACC.thirtyDayMask.getThirtyDayMaskProductList(searchTermVal, maskBrandSel, configTypeSel, false);
  },
  createOrderForMask: function() {
    var savedList = JSON.parse(localStorage.getItem(ACC.thirtyDayMask.savedListLabel)),
        purchaseOrderNumber = localStorage.getItem(ACC.repairProducts.poNumber),
        deliveryAddressid = localStorage.getItem(ACC.repairProducts.selectedAddrString),
        orderCode = '.ph-order-num ',
        errorlabel = $('.ph-mask-error').text();

    $('#ph-thirtyday_orderedlist').html($('#thirtyDaySavedList').tmpl({
      productList: savedList
    }));
    ACC.thirtyDayMask.onSubmitofMaskOrder();

    function createSaveListObject(element) {
      var obj = {
        product: {}
      };

      obj.quantity = element.quantity;
      obj.product.name = element.name;
      obj.product.code = element.code;

      return obj;
    }

    var arrayofsavelist = savedList.map(createSaveListObject);
    var orderMaskData = {
      purchaseOrderNumber: purchaseOrderNumber,
      entries: arrayofsavelist,
      deliveryMode: {
        code: '02',
        name: 'Standard Delivery'
      },
      deliveryAddress: {
        id: deliveryAddressid
      }
    };

    if (savedList) {
      $.ajax({
        url: ACC.config.contextPath + 'thirty-day-mask/createOrder',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: JSON.stringify(orderMaskData),
        success: function(data) {
          if (data) {
            $(orderCode).html(data);
          } else {
            $(orderCode).html(errorlabel);
          }

          localStorage.removeItem(ACC.thirtyDayMask.defaultBrandLabel);
        },
        error: function() {
          $(orderCode).html(errorlabel);
        }
      });
    }
  },
  createOrderSummaryofMask: function() {
    var savedList = JSON.parse(localStorage.getItem(ACC.thirtyDayMask.savedListLabel));

    $('#ph-thirtyday_orderedlist_reviewPge').html($('#thirtyDaySavedList').tmpl({
      productList: savedList
    }));
  },
  onSubmitofMaskOrder: function() {
    location.hash = 'maskThankyouPage';

    var date = new Date();
    var options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    };
    var stringDate = date.toLocaleDateString('en-US', options);

    $('.ph-mask__date').html(stringDate);
    $('.ph-po-num').html(localStorage.getItem(ACC.repairProducts.poNumber));
  },
  enableSubmit: function() {
    $(ACC.thirtyDayMask.reviewSubmitBtnCls).removeClass(ACC.thirtyDayMask.disableButtonCls);
    $(ACC.thirtyDayMask.acceptTermsBtnBig).addClass('ph-green_tick_icon');
  },
  disableSubmit: function() {
    $(ACC.thirtyDayMask.reviewSubmitBtnCls).addClass(ACC.thirtyDayMask.disableButtonCls);
    $(ACC.thirtyDayMask.acceptTermsBtnBig).removeClass('ph-green_tick_icon');
  },
  getTotalQuantity: function() {
    var savedList = JSON.parse(localStorage.getItem(ACC.thirtyDayMask.savedListLabel)),
        totalQuantity = 0;

    if (savedList) {
      Object.keys(savedList).forEach(function(key) {
        totalQuantity = totalQuantity + savedList[key].quantity;
      });
    }

    $('.ph-total_mask_quantity').html(totalQuantity);
  },
  colorboxCls: function(href, close, width) {
    $.colorbox({
      inline: true,
      href: href,
      width: '100%',
      maxWidth: width,
      scrolling: true,
      overlayClose: false,
      escKey: true,
      close: close,
      onComplete: function() {
        $('#colorbox').removeClass(ACC.thirtyDayMask.shippingPopupCls);
      },
      onClosed: function() {
        $.colorbox.close();
      }
    });
  },
  backButtonFunctions: function() {
    $('.ph-build-backbtn').click(function() {
      ACC.thirtyDayMask.navigateToHome();
    });
    $('.ph-review-backbtn').click(function() {
      ACC.thirtyDayMask.navigateToBuild();
    });
  },
  termsAndConditionsPopupFunctions: function() {
    $('.ph-accept_terms_btn, .ph-term_cond_link').click(function() {
      var popupWidth = '60%',
          href = '#ph-termsconditions-popup',
          close = '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>';

      if ($(window).width() <= 768) {
        popupWidth = '95%';
      }

      ACC.thirtyDayMask.colorboxCls(href, close, popupWidth);
    });
    $(document).on('click', '.ph-terms_popup_notagree', function() {
      ACC.thirtyDayMask.disableSubmit();
      $.colorbox.close();
    });
    $(document).on('click', ACC.thirtyDayMask.termsCondPopupAgreeCls, function() {
      ACC.thirtyDayMask.enableSubmit();
      $.colorbox.close();
    });
    $('input[id="MASK_REVIEW_TC"]').click(function() {
      if ($(this).is(':checked')) {
        $(ACC.thirtyDayMask.termsCondPopupAgreeCls).removeClass(ACC.thirtyDayMask.disableButtonCls);
      } else if ($(this).is(':not(:checked)')) {
        $(ACC.thirtyDayMask.termsCondPopupAgreeCls).addClass(ACC.thirtyDayMask.disableButtonCls);
      }
    });
  },
  bindAll: function() {
    $('.ph-30daymask_aboutlink').click(function() {
      var popupWidth = 640,
          href = '#ph-thirtyday-pgmdetails',
          close = '<button type=\'button\' class=\'ph-cbox-close\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>';

      ACC.thirtyDayMask.colorboxCls(href, close, popupWidth);
    });
    $('.ph-thirtyday_popup_ok').click(function() {
      $.colorbox.close();
    });
    $('.ph-thirtydaymask_startbtn').click(function() {
      $(ACC.thirtyDayMask.leftNavigation).hide();
      $('#' + ACC.thirtyDayMask.breadcrumb).addClass(ACC.thirtyDayMask.breadcrumbCls);
      ACC.thirtyDayMask.getThirtyDayMaskProductList('', ACC.thirtyDayMask.defaultBrand, ACC.thirtyDayMask.defaultConfigType, true);
      location.hash = 'build';
    });
    $('.ph-accumulatordata').click(function() {
      var popupWidth = '60%',
          href = '#ph-accumulator-popup',
          close = '<button type=\'button\' class=\'ph-cbox-close ph-thirtyday_closelist\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>';

      if ($(window).width() <= 768) {
        popupWidth = '95%';
      }

      ACC.thirtyDayMask.colorboxCls(href, close, popupWidth);
    });
    $(document).on('click', '.ph-btn-minus', function() {
      var rowIndex = $(this).attr('data-index');

      ACC.thirtyDayMask.updateQty(rowIndex, false);
    });
    $(document).on('click', '.ph-btn-plus', function() {
      var rowIndex = $(this).attr('data-index');

      ACC.thirtyDayMask.updateQty(rowIndex, true);
    });
    $('.ph-savetolist_icon').click(function() {
      var toBeSavedList = '',
          cartItems = ACC.thirtyDayMask.savedList.length;

      if (cartItems === 0) {
        ACC.thirtyDayMask.savedList = ACC.thirtyDayMask.returnSelectedProducts();
        ACC.thirtyDayMask.createCartItems();
      } else {
        toBeSavedList = ACC.thirtyDayMask.returnSelectedProducts();
        ACC.thirtyDayMask.updateExistingCartItems(toBeSavedList);
      }

      if (ACC.thirtyDayMask.savedList.length > 0) {
        ACC.thirtyDayMask.updatePopupTemplate();
        ACC.thirtyDayMask.enableAccumulatorIcon();
        ACC.thirtyDayMask.persistSavedList();
        ACC.thirtyDayMask.clearUpdatedList();
        ACC.thirtyDayMask.totalQty = 0;
        $('.' + ACC.thirtyDayMask.buildNextBtnCls).removeClass(ACC.thirtyDayMask.disableButtonCls);
        $('.ph-prdquantity').val(0);
        ACC.thirtyDayMask.disableSaveToList();
      }
    });
    $(document).on('click', '.ph-thirtyday_deleteprd', function() {
      var productcode = $(this).attr('data-productcode'),
          filteredItem = '';

      if (ACC.thirtyDayMask.savedList.length > 0) {
        ACC.thirtyDayMask.savedList = ACC.thirtyDayMask.savedList.filter(function(item) {
          filteredItem = item.code !== productcode;

          return filteredItem;
        });
        ACC.thirtyDayMask.enableAccumulatorIcon();
        ACC.thirtyDayMask.createCartItems();
        ACC.thirtyDayMask.updatePopupTemplate();
      }

      if (ACC.thirtyDayMask.savedList.length === 0) {
        ACC.thirtyDayMask.disableAccumulatorIcon();
        $('.' + ACC.thirtyDayMask.buildNextBtnCls).addClass(ACC.thirtyDayMask.disableButtonCls);
        $.colorbox.close();
      }

      ACC.thirtyDayMask.persistSavedList();
    });
    $(document).on('click', '.ph-cartbtn-minus', function() {
      var rowIndex = $(this).attr('data-productindex');

      ACC.thirtyDayMask.updateCartQty(rowIndex, false);
    });
    $(document).on('click', '.ph-cartbtn-plus', function() {
      var rowIndex = $(this).attr('data-productindex');

      ACC.thirtyDayMask.updateCartQty(rowIndex, true);
    });
    $(document).on('click', '.ph-thirtyday_savelist', function() {
      ACC.thirtyDayMask.savedList = ACC.thirtyDayMask.savedList.map(function(item) {
        item.quantity = item.cartQuantity;

        return item;
      });
      ACC.thirtyDayMask.enableAccumulatorIcon();
      ACC.thirtyDayMask.persistSavedList();
      ACC.thirtyDayMask.updatePopupTemplate();

      $.colorbox.close();
    });
    $(document).on('click', '.ph-thirtyday_closelist', function() {
      ACC.thirtyDayMask.savedList = ACC.thirtyDayMask.savedList.map(function(item) {
        item.cartQuantity = item.quantity;

        return item;
      });
      ACC.thirtyDayMask.updatePopupTemplate();
      $.colorbox.close();
    });
    ACC.thirtyDayMask.backButtonFunctions();
    ACC.thirtyDayMask.termsAndConditionsPopupFunctions();
    $(document).on('change', '#maskBrand', function() {
      var maskBrandVal = $(this).val(),
          configTypeVal = $('input[name="configType"]:checked').val();

      if (!configTypeVal) {
        configTypeVal = '';
      }

      ACC.thirtyDayMask.searchByParameters(maskBrandVal, configTypeVal);
    });
    $(document).on('change', '.ph-configtype', function() {
      var maskBrandVal = $(ACC.thirtyDayMask.maskBrandDropDown).val(),
          configTypeVal = $(this).val();

      ACC.thirtyDayMask.searchByParameters(maskBrandVal, configTypeVal);
    });
    $('.ph-thirtydat_searchbtn').click(function() {
      var searchTerm = $('.' + ACC.thirtyDayMask.searchinput).val();

      if ($.trim(searchTerm).length > 0) {
        ACC.thirtyDayMask.defaultBrand = '';
        $('.ph-configtype').prop('checked', false);
        $(ACC.thirtyDayMask.maskBrandDropDown).val('');
        $(ACC.thirtyDayMask.maskBrandDropDown).selectBox(ACC.thirtyDayMask.selectBoxRefresh);
        ACC.thirtyDayMask.getThirtyDayMaskProductList(searchTerm, '', '', false);
      }
    });
    $('.ph-thirtyday__search .ph-freetextsearch__input').keyup(function(e) {
      var searchTerm = $('.' + ACC.thirtyDayMask.searchinput).val(),
          mBrand = $(ACC.thirtyDayMask.maskBrandDropDown).val(),
          cType = $('input[name="configType"]:checked').val();

      if (!cType) {
        cType = '';
      }

      if (e.which === 13) {
        $('.ph-thirtydat_searchbtn').click();
      } else if ($(this).val().length === 0) {
        ACC.thirtyDayMask.getThirtyDayMaskProductList(searchTerm, mBrand, cType, false);
      }
    });
    $(document).on('click', '.ph-build-nextbtn', function() {
      ACC.thirtyDayMask.createOrderSummaryofMask();
      location.hash = '#reviewSubmit';
      ACC.thirtyDayMask.getTotalQuantity();
    });
    $(document).on('click', ACC.thirtyDayMask.reviewSubmitBtnCls, function() {
      location.hash = '#maskThankyouPage';
      ACC.thirtyDayMask.createOrderForMask();
      $('#' + ACC.thirtyDayMask.breadcrumb).hide();
    });
  }
};
$(document).ready(function() {
  if ($('#thirtyDayHome').length > 0) {
    if (location.hash === '' || location.hash === '#reviewSubmit' || location.hash === '#maskThankyouPage') {
      ACC.thirtyDayMask.navigateToHome();
      localStorage.removeItem(ACC.thirtyDayMask.savedListLabel);
    }

    if (location.hash === '#thirtyDayHome') {
      ACC.thirtyDayMask.getDefaultBrand();
      $(ACC.thirtyDayMask.leftNavigation).show();
    }

    if (location.hash === '#build') {
      $(ACC.thirtyDayMask.leftNavigation).hide();
      ACC.thirtyDayMask.getDefaultBrand();
      ACC.thirtyDayMask.populateSavedListOnLoad();
      $('#' + ACC.thirtyDayMask.breadcrumb).addClass(ACC.thirtyDayMask.breadcrumbCls);
    }
  }

  ACC.thirtyDayMask.bindAll();
});
